import React, { useEffect, useState } from "react";
import {
  Card,
  Input,
  Button,
  Typography,
  message,
  Spin,
  Table,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";
import {
  getSystemSettings,
  updateSystemSetting,
} from "../../endpoints/API";

const { Title, Text } = Typography;

function SystemSettings() {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await getSystemSettings();
      setSettings(res.data);
    } catch (err) {
      message.error("Failed to fetch system settings");
    } finally {
      setLoading(false);
    }
  };

  const handleValueChange = (id, value) => {
    setSettings((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, value } : item
      )
    );
  };

  const handleSave = async (id, value) => {
    if (!value) {
      message.warning("Value cannot be empty");
      return;
    }

    setSavingId(id);
    try {
      await updateSystemSetting(id, { value });
      message.success("Setting updated successfully");
    } catch (err) {
      message.error("Failed to update setting");
    } finally {
      setSavingId(null);
    }
  };

  const columns = [
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) =>
            handleValueChange(record.id, e.target.value)
          }
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          loading={savingId === record.id}
          onClick={() =>
            handleSave(record.id, record.value)
          }
        >
          Save
        </Button>
      ),
    },
  ];

  return (
    <Card
      style={{
        maxWidth: 800,
        margin: "2rem auto",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <Title level={4}>
        {/* <SettingOutlined
          style={{ marginRight: 8, color: "#1890ff" }}
        /> */}
        System Settings
      </Title>

      {loading ? (
        <Spin />
      ) : (
        <Table
          dataSource={settings}
          columns={columns}
          rowKey="id"
          pagination={false}
        />
      )}
    </Card>
  );
}

export default SystemSettings;
